var React = require("react");

class LoadingPlaceholder extends React.Component {
    
    render() {
        let { isError = false, getButtons } = this.props

        return (
           <React.Fragment>
               <div className="throbber">
                    {!isError && <React.Fragment>
                                    <div className="throbber__bounce1"></div>
                                    <div className="throbber__bounce2"></div>
                                    <div className="throbber__bounce3"></div>
                                </React.Fragment>}
                    {isError && <div className="throbber__error"></div>}
                </div>
                {getButtons && getButtons()}
             </React.Fragment>
        );
    }
}


module.exports = LoadingPlaceholder;
